module.exports = __webpack_public_path__ + "media/entities/1403-54bda427.png";